import { fetchAgencyData } from '@/lib/backend-api'
import React, { ReactElement } from 'react'
import { Domain, ExtendedDomainConfiguration } from '../../../domain-config/domain-config'
import { SearchResultElementProps } from '@/components/ui/search/SearchResults'
import { GetStaticPropsResult, Metadata } from 'next'
import { getConfiguration } from '@/lib/utilsUsableOnEdgeRuntime'
import SearchResultList from '@/components/pages/search-page/SearchResultList'
import SearchPageModals from '@/components/pages/search-page/SearchPageModals'
import {
  AppProps,
  loadBasicPageData,
} from '../../../app/protected/[locale]/[domain]/[currency]/[agency]/[testvariants]/[pagetype]/layout-helper'
import { AgencyData } from '@/types/Misc'
import { getMessages } from '@/lib/utils/i18n'

export const HOTEL_FOCUSED_EVENT = 'HOTEL_FOCUSED_EVENT'
export const HOTEL_UNFOCUSED_FOCUSED_EVENT = 'HOTEL_UNFOCUSED_FOCUSED_EVENT'

export const DUMMY_SEARCH_RESULT: SearchResultElementProps[] = Array<SearchResultElementProps>(
  5,
).fill({
  skeleton: true,
  hotel: {
    Description: '',
    Destinations: [],
    Discount: '',
    HotelCategoryStars: 0,
    HotelCategoryText: '',
    SpecialCategory: '',
    Annotation: '',
    HotelCode: '',
    HotelName: '',
    Images: [],
    RatingText: '',
    RatingValue: 0,
    SearchResultOffers: [],
    IsKmwHotel: false,
    Url: '',
    UniqueSellingPoints: [],
    LikesCount: 9,
    Popularities: [],
    TopBar: '',
  },
  domain: Domain.FITREISEN_DE,
  hotelName: '',
})

export async function getStaticProps({
  params: { domain, agency, testvariants },
}: {
  params: {
    domain: Domain
    agency: number
    testvariants: string
  }
}): Promise<
  GetStaticPropsResult<{
    domain: Domain
    agency: AgencyData
    config: ExtendedDomainConfiguration
    testvariants: string
  }>
> {
  const agencyData = await fetchAgencyData(domain, agency)
  const config = await getConfiguration(domain)
  return {
    props: {
      domain: domain,
      agency: agencyData,
      config: config,
      testvariants: testvariants,
    },
  }
}

interface SearchPageProps extends AppProps {
  skipHeaderAndFooter: boolean
  bookmarksPage: boolean
}

export async function generateMetadata(props: AppProps): Promise<Metadata> {
  await loadBasicPageData({ ...props, whitelabel: false })
  const messages = await getMessages()
  const pageTitle = messages['PageTitle']
  const search = pageTitle['search']

  return {
    title: search,
    robots: {
      index: false,
      follow: true,
    },
  }
}

export function getSearchPageComponent(
  skipHeaderAndFooter: boolean,
  bookmarksPage?: boolean,
): (props: AppProps) => Promise<ReactElement> {
  return async (props: AppProps): Promise<ReactElement> => {
    const extendedProps = {
      ...props,
      skipHeaderAndFooter: skipHeaderAndFooter,
      bookmarksPage: !!bookmarksPage,
    }
    return await SearchPage(extendedProps)
  }
}

export default async function SearchPage(props: SearchPageProps): Promise<ReactElement> {
  await loadBasicPageData({ ...props, whitelabel: false })
  // const messages = await getMessages()

  return (
    <>
      <SearchResultList
        skipHeaderAndFooter={props.skipHeaderAndFooter}
        bookmarksPage={props.bookmarksPage}
      />
      <SearchPageModals currency={props.params.currency} />
    </>
  )
}
